import React from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid/models/params/gridCellParams';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { SuperAdminUser } from '../../../../types';
import Stack from '@mui/material/Stack';

interface Props {
  params: GridRenderCellParams;
  hideDelete: boolean;
  onRemoveClick: (selectedUser: SuperAdminUser) => void;
  onEditClick: (selectedUser: SuperAdminUser) => void;
}

const DeleteUserRow = ({ params, hideDelete, onRemoveClick, onEditClick }: Props) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <IconButton onClick={() => onEditClick(params.row)}>
        <EditIcon />
      </IconButton>
      {!hideDelete ? (
        <IconButton onClick={() => onRemoveClick(params.row)}>
          <DeleteIcon color="error" />
        </IconButton>
      ) : (
        <></>
      )}
    </Stack>
  );
};

export default DeleteUserRow;
